import React from 'react';
import { Form, Input, Button, Icon } from 'antd';
import VideoUpload from './../editcourseform/elements/videoupload';
import Lecturefiles from './files';

export default ({

  handleVideoChange,
  getFieldDecorator,
  sectionId,
  media, uploadMedia,
  uploadFile,removeFile,
  getMedia,
  refreshVideos, refresh,
  profile,
  lectureId,
  lecture,
  lecturesLength,
  removeLecture,
  lectureIndex,
  sectionIndex,
  videoUrl,
  showUpLoadFileForm,
  onUploadFileForm,
  offUploadFileForm
}) => (
    <div className="lecture-content">
      <Form.Item label="lecture title">
        {lecturesLength >= 2 ? (
          <Button
            onClick={() => removeLecture(sectionId, lectureIndex)}
            className="remove-lecture-btn"
            size="small"
            type="danger"
          >
            Remove Lecture
        </Button>
        ) : (
            ''
          )}
        {getFieldDecorator(`${sectionId}|title|${lectureId}`, {
          initialValue: lecture.title,
          rules: [
            { required: true, message: 'Please input your lecture title!' }]
        })(<Input placeholder="lecture title" name="title" size="default" />)}
      </Form.Item>

      <Form.Item label="Upload Lecture Video">
        <div className="upload-lecture">
          <VideoUpload
            media={media}
            uploadMedia={uploadMedia}
            refreshVideos={refreshVideos}
            refresh={refresh}
            getMedia={getMedia}
            profile={profile}
            videoUrl={videoUrl}
            getFieldDecorator={getFieldDecorator}
            handleVideoChange={videoUrl =>
              handleVideoChange(videoUrl, sectionId, lectureId)
            }
          />
        </div>
      </Form.Item>
      <div className="add-lecfile">
        <Lecturefiles 
        profile={profile}
        uploadFile={uploadFile}
        files={lecture.files}
        removeFile={removeFile}
        lectureIndx={parseInt(lectureIndex)}
        sectionIndx={parseInt(sectionIndex)}
        />
      </div>
    </div>
  );
